import React from 'react';

import { useStyles } from '~/assets/styles';
import Button from '~/components/core/Atomic/Buttons/Button';
import Text from '~/components/core/TextComponents/Text';
import { PencilIcon, SearchIcon } from '~/components/icons';
import cn from '~/Utils/cn';

export interface PolicySelectionButtonProps {
  policyNumber?: string;
  viewOnly?: boolean;
  onClick?: () => void;
}

export const PolicySelectionButton: React.FC<PolicySelectionButtonProps> = ({
  policyNumber,
  viewOnly = false,
  onClick,
}) => {
  const { classes } = useStyles();

  const onClickHandler = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    if (viewOnly) return;
    onClick && onClick();
  };

  // When policy exists, show as link
  if (policyNumber) {
    return (
      <div className="flex items-center">
        <span
          className={cn(classes.subtleLinkText, !viewOnly ? 'cursor-pointer pr-4 underline' : '')}
          onClick={onClickHandler}
        >
          <Text weight={Text.WEIGHTS.MEDIUM} variant={Text.VARIANTS.XS}>
            {policyNumber}
          </Text>
        </span>
        {!viewOnly && (
          <span onClick={onClickHandler} className="cursor-pointer" title="Change policy">
            <PencilIcon className="text-gray-600" size={12} />
          </span>
        )}
      </div>
    );
  }

  // When no policy, show "FIND POLICY" button only if not viewOnly
  if (!viewOnly) {
    return (
      <Button variant="outlined" color="primary" onClick={onClickHandler} className="min-w-max">
        <span className="flex items-center gap-8">
          <Text className="text-blue-500" weight={Text.WEIGHTS.MEDIUM} variant={Text.VARIANTS.SM}>
            FIND POLICY
          </Text>
          <SearchIcon className="stroke-blue-500" size={16} />
        </span>
      </Button>
    );
  }

  // When viewOnly and no policy, return nothing
  return null;
};
